import { ID, Response } from "../../../../../_metronic/helpers"

// import {ID, Response} from '../../../../../../_metronic/helpers'
export type Tenant = {
  id?: ID
  name?: string
  avatar?: string
  email?: string
  mobile?: string
  role?: string
  dob?: string
  position?: string
  appartment?: String
  tenant_info?: string
  two_steps?: boolean
  property_info?: boolean
  joined_day?: string
  online?: boolean
  initials?: {
    label: string
    state: string
  }
}

export type TenantsQueryResponse = Response<Array<Tenant>>

export const initialTenant: Tenant = {
  avatar: 'avatars/300-6.jpg',
   position: 'Art Director',
   role: 'Administrator',
  name: '',
  email: '',
}
